import { Launch as LaunchIcon } from '@mint-lib/icons';
import { typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

type Props = {
  data: string[];
};

const WebSourceTabData = ({ data }: Props) => {
  const linkTypography = typographyVariants({
    variant: 'bodyLong01',
    color: 'link',
    link: true,
  });

  return (
    <div className="flex flex-col gap-3">
      {data.map((source) => (
        <a
          key={source}
          className={cn('flex items-center gap-2', linkTypography)}
          target="_blank"
          href={`https://${source}`}
        >
          <LaunchIcon />
          {source}
        </a>
      ))}
    </div>
  );
};

export { WebSourceTabData };
